import { render } from "./FirstView.vue?vue&type=template&id=11f34722"
import script from "./FirstView.vue?vue&type=script&lang=js"
export * from "./FirstView.vue?vue&type=script&lang=js"

import "./FirstView.vue?vue&type=style&index=0&id=11f34722&lang=css"

import exportComponent from "C:\\wamp64\\www\\police-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__